var _g, _path, _g2, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTemplateIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2583_71400)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_2583_71400)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.636 11.0991H27.6359C16.4569 11.0991 7.39453 20.1615 7.39453 31.3405V31.3406C7.39453 42.5196 16.4569 51.582 27.6359 51.582H27.636C38.815 51.582 47.8774 42.5196 47.8774 31.3406V31.3405C47.8774 20.1615 38.815 11.0991 27.636 11.0991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7534 31.3406C47.7534 20.2298 38.7463 11.2227 27.6355 11.2227C16.5247 11.2227 7.51758 20.2298 7.51758 31.3406C7.51758 42.4514 16.5247 51.4585 27.6355 51.4585C38.7463 51.4585 47.7534 42.4514 47.7534 31.3406Z",
    stroke: "#FAFAFB",
    strokeWidth: 0.236047
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2583_71400",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 9,
    width: 41,
    height: 35
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.8774 9.12427H7.39453V43.9296H47.8774V9.12427Z",
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2583_71400)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.7534 31.3403C47.7534 20.2295 38.7463 11.2224 27.6355 11.2224C16.5247 11.2224 7.51758 20.2295 7.51758 31.3403C7.51758 42.4511 16.5247 51.4582 27.6355 51.4582C38.7463 51.4582 47.7534 42.4511 47.7534 31.3403Z",
    stroke: "#F5F6F6",
    strokeWidth: 0.236047
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.7534 31.3403C47.7534 20.2295 38.7463 11.2224 27.6355 11.2224C16.5247 11.2224 7.51758 20.2295 7.51758 31.3403C7.51758 42.4511 16.5247 51.4582 27.6355 51.4582C38.7463 51.4582 47.7534 42.4511 47.7534 31.3403Z",
    fill: "url(#paint0_linear_2583_71400)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8379 14.3574C11.8379 12.6984 11.8379 11.8689 12.1608 11.2353C12.4447 10.6779 12.8979 10.2248 13.4553 9.94078C14.0889 9.61792 14.9184 9.61792 16.5774 9.61792H38.6948C40.3535 9.61792 41.1833 9.61792 41.8168 9.94078C42.3743 10.2248 42.8274 10.6779 43.1114 11.2353C43.4343 11.8689 43.4343 12.6984 43.4343 14.3574V44.1762H11.8379V14.3574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4972 16.5295H32.0792C31.5339 16.5295 31.0918 16.9716 31.0918 17.5169V17.5169C31.0918 18.0622 31.5339 18.5043 32.0792 18.5043H38.4972C39.0425 18.5043 39.4845 18.0622 39.4845 17.5169C39.4845 16.9716 39.0425 16.5295 38.4972 16.5295Z",
    fill: "#E6F5F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3292 16.4446H16.9112C16.3659 16.4446 15.9238 16.8866 15.9238 17.432V17.432C15.9238 17.9773 16.3659 18.4193 16.9112 18.4193H23.3292C23.8745 18.4193 24.3166 17.9773 24.3166 17.432C24.3166 16.8866 23.8745 16.4446 23.3292 16.4446Z",
    fill: "#E6F5F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4879 20.4792H30.9464C30.4011 20.4792 29.959 20.9213 29.959 21.4666V21.4666C29.959 22.0119 30.4011 22.454 30.9464 22.454H38.4879C39.0333 22.454 39.4753 22.0119 39.4753 21.4666C39.4753 20.9213 39.0333 20.4792 38.4879 20.4792Z",
    fill: "#F5F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4528 20.394H16.9112C16.3659 20.394 15.9238 20.8361 15.9238 21.3814V21.3814C15.9238 21.9267 16.3659 22.3688 16.9112 22.3688H24.4528C24.9981 22.3688 25.4402 21.9267 25.4402 21.3814C25.4402 20.8361 24.9981 20.394 24.4528 20.394Z",
    fill: "#F5F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.497 26.4033H16.7745C16.2292 26.4033 15.7871 26.8454 15.7871 27.3907V27.3907C15.7871 27.936 16.2292 28.3781 16.7745 28.3781H38.497C39.0423 28.3781 39.4843 27.936 39.4843 27.3907C39.4843 26.8454 39.0423 26.4033 38.497 26.4033Z",
    fill: "#E6F5F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4963 31.3403H18.255C17.7096 31.3403 17.2676 31.7824 17.2676 32.3277V32.3277C17.2676 32.873 17.7096 33.3151 18.255 33.3151H38.4963C39.0417 33.3151 39.4837 32.873 39.4837 32.3277C39.4837 31.7824 39.0417 31.3403 38.4963 31.3403Z",
    fill: "#F5F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4974 36.2773H17.2686C16.7233 36.2773 16.2812 36.7194 16.2812 37.2647V37.2647C16.2812 37.81 16.7233 38.2521 17.2686 38.2521H38.4974C39.0427 38.2521 39.4848 37.81 39.4848 37.2647C39.4848 36.7194 39.0427 36.2773 38.4974 36.2773Z",
    fill: "#E6F5F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4969 41.2141H23.1925C22.6471 41.2141 22.2051 41.6562 22.2051 42.2015V42.2015C22.2051 42.7468 22.6471 43.1889 23.1925 43.1889H38.4969C39.0422 43.1889 39.4843 42.7468 39.4843 42.2015C39.4843 41.6562 39.0422 41.2141 38.4969 41.2141Z",
    fill: "#F5F6F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9609 14.3575C11.9609 13.526 11.961 12.9098 12.0009 12.422C12.0406 11.9357 12.1193 11.588 12.2704 11.2914C12.5425 10.7573 12.9768 10.323 13.5109 10.0509C13.8074 9.89979 14.1552 9.82114 14.6415 9.78142C15.1292 9.74157 15.7454 9.74146 16.577 9.74146H38.6944C39.526 9.74146 40.142 9.74157 40.6299 9.78142C41.1163 9.82114 41.464 9.89979 41.7605 10.0509C42.2945 10.323 42.7289 10.7573 43.0009 11.2914C43.1521 11.588 43.2308 11.9357 43.2703 12.422C43.3102 12.9098 43.3105 13.526 43.3105 14.3575V44.053H11.9609V14.3575Z",
    stroke: "#F5F6F6",
    strokeWidth: 0.236047
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.31445 10.5229V15.8301",
    stroke: "#AEE1E6",
    strokeWidth: 0.525,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.38672 12.9021H8.69391",
    stroke: "#AEE1E6",
    strokeWidth: 0.525,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2812 1.00659V6.31378",
    stroke: "#AEE1E6",
    strokeWidth: 0.525,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3535 3.38574H45.6607",
    stroke: "#AEE1E6",
    strokeWidth: 0.525,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9668 20.0393V25.3465",
    stroke: "#AEE1E6",
    strokeWidth: 0.525,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0391 22.4182H53.3463",
    stroke: "#AEE1E6",
    strokeWidth: 0.525,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_2583_71400",
    x: 0.549168,
    y: 4.48981,
    width: 54.8813,
    height: 55.1178,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.472094,
    dy: 0.944184
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5407
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2583_71400"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.236047,
    dy: 0.472094
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5407
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2583_71400",
    result: "effect2_dropShadow_2583_71400"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2583_71400",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2583_71400",
    x1: 27.6355,
    y1: 7.64313,
    x2: 27.6355,
    y2: 59.3573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.377241,
    stopColor: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2FEFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2583_71400"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplateIcon);
export default __webpack_public_path__ + "static/media/template-icon.47ba0b63bf724ec1a2be499fd8f9dd53.svg";
export { ForwardRef as ReactComponent };